var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoiceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4 13.4H26V9.8C26 8.80589 25.1941 8 24.2 8M22.4 13.4V9.8C22.4 8.80589 23.2059 8 24.2 8M22.4 13.4V26L18.8 24.2L15.2 26L11.6 24.2L8 26V9.80001C8 8.8059 8.80589 8.00001 9.8 8.00001L24.2 8",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1994 12.9506C14.2053 12.9506 13.3994 13.555 13.3994 14.3006C13.3994 15.0462 14.2053 15.6506 15.1994 15.6506C16.1936 15.6506 16.9994 16.255 16.9994 17.0006C16.9994 17.7461 16.1936 18.3506 15.1994 18.3506M15.1994 12.9506C15.9831 12.9506 16.6499 13.3262 16.897 13.8506M15.1994 12.9506V11.6006M15.1994 18.3506C14.4157 18.3506 13.7489 17.9749 13.5018 17.4506M15.1994 18.3506V19.7006",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceIcon);
export default __webpack_public_path__ + "static/media/invoice_icon.df92b0a1e852c7342f55b08a7f9043f8.svg";
export { ForwardRef as ReactComponent };